const LocalStore = require('./local-store.js');
const MemoryStore = require('./memory-store.js');

module.exports = { LocalStore, MemoryStore };
